import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {PartnerResponse} from '../model/partner';

@Injectable()
export class PartnerService {
    private readonly httpClient: HttpClient;

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public async getPartnerNameByCode(partnerId: string): Promise<string> {
        return this.httpClient.get<string>(ConfigService.getPartnerServiceUrl() + `/api/partner/${partnerId}/verify`).toPromise();
    }

    public async getPartnerByUserId(userId: string): Promise<PartnerResponse> {
        const params = new HttpParams().set('userId', userId);
        return this.httpClient.get<PartnerResponse>(ConfigService.getPartnerServiceUrl() + `/api/partner`, {params}).toPromise();
    }
}
